import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "./NavLinkCust";

const MasteryContainer = () => {
    return (
        <React.Fragment>
            <div className="MasteryContainer">
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Business</span>
                </NavLink>
                {/* <NavLinkCust url="viantech" clsName="MasteryBodySpan"/> */}{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Finance</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Collections</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Audit</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Marketing</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Data Analytics</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Accounting</span>
                </NavLink>{" "}
                <NavLink
                    className="hover-color"
                    to={process.env.PUBLIC_URL + "/viantech"}
                >
                    <span className="MasteryBodySpan">Aanalyst</span>
                </NavLink>
            </div>
        </React.Fragment>
    );
};

export default MasteryContainer;
